import React from "react";
import {
  Box,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Card,
  CardMedia,
  CardActionArea,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import treeBlank from "../../assets/img/trees/blank.png";
import {
  LoadedImage,
  LoadedImageBox,
  LoadedImageRemove,
  LoadedImagesContainer,
  MainTitle,
  QRCodeContainer,
  TreeBlankImg,
  CustomQRCodeExampleContainer,
} from "./styles";
import Button from "@mui/material/Button";
import AlertSuccess from "../../components/AlertSuccess";
import MapSelect from "../../components/MapSelect";
import TreeAutocomplete from "../../components/TreeAutocomplete/TreeAutocomplete";
import QRCodeConfigurator, {
  TypeConfigurator,
} from "../../components/QRCodeConfigurator";
import { qrCodeImages, treePositions } from "./constants";
import { LoadButton, Textarea } from "./controls";
import RepeatableTextImageSection from "./RepeatableTextImageSection";
import { useChangePageForm } from "./useChangePageForm";
import { getCustomImageSize } from "./utils";
export {
  initialState,
  type AnketaService,
  type AnketaTextImageBlock,
  type IAllowFields,
  type IAnketa,
  type IRelationsResult,
  type ITarriff,
  type ITree,
} from "./model";

const ChangePage = () => {
  const {
    address,
    allowFields,
    anketa,
    handleSelectImage,
    handleServicePriceChange,
    handleSubmit,
    id,
    initialRelation,
    newCoords,
    openSaveAlert,
    qrCode,
    qrSrc,
    r,
    refQR,
    relationsResult,
    selectedImages,
    setAddress,
    setAnketa,
    setNewCoords,
    setOpenSaveAlert,
    setRelationsResult,
    tariffid,
  } = useChangePageForm();

  return (
    <>
      <Container
        style={{ marginTop: "120px", paddingLeft: "0px", paddingRight: "0px" }}
      >
        <MainTitle variant="h4" sx={{ marginBottom: "40px" }}>
          {tariffid ? "Новая анкета" : "Редактировать анкету от 02.06.2025"}
        </MainTitle>
        <Grid
          component="form"
          noValidate
          autoComplete="off"
          sx={{ marginLeft: "auto", marginRight: "auto" }}
        >
          <h4>Основная информация</h4>
          <Grid item xs={12} md={12} sx={{ m: 1 }}>
            {!r && (
              <>
                {/* <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() =>
                        setAnketa((prev) => ({
                          ...prev,
                          orderStatus:
                            prev.orderStatus === "PAYED" ? "NEW" : "PAYED",
                        }))
                      }
                      checked={anketa?.orderStatus === "PAYED"}
                    />
                  }
                  label="Страница оплачена"
                /> */}
                <FormControlLabel
                  control={<Checkbox checked={!anketa.hidden} />}
                  onChange={() =>
                    setAnketa((prev) => ({
                      ...prev,
                      hidden: !prev.hidden,
                    }))
                  }
                  label="Страница опубликована"
                />
              </>
            )}
          </Grid>
          <FormControl fullWidth sx={{ m: 1 }}>
            <TextField
              id="outlined-basic1"
              label="ФИО"
              variant="outlined"
              value={anketa.name}
              onChange={(e) => {
                setAnketa({
                  ...anketa,
                  name: e.target.value,
                });
              }}
            />
          </FormControl>
          {allowFields?.solder && (
            <>
              <FormControl fullWidth sx={{ m: 1 }}>
                <TextField
                  id="outlined-basic1"
                  label="Звание"
                  variant="outlined"
                  value={anketa.rang}
                  onChange={(e) => {
                    setAnketa({
                      ...anketa,
                      rang: e.target.value,
                    });
                  }}
                />
              </FormControl>
            </>
          )}
          <FormControl fullWidth sx={{ m: 1 }}>
            <Grid container spacing={2}>
              <Grid item xs={6} md={6}>
                <TextField
                  fullWidth
                  id="outlined-basic2"
                  label="Дата рождения"
                  variant="outlined"
                  value={anketa.dateBorn}
                  onChange={(e) => {
                    setAnketa({
                      ...anketa,
                      dateBorn: e.target.value,
                    });
                  }}
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <TextField
                  fullWidth
                  id="outlined-basic2"
                  label="Дата смерти"
                  variant="outlined"
                  value={anketa.dateEnd}
                  onChange={(e) => {
                    setAnketa({
                      ...anketa,
                      dateEnd: e.target.value,
                    });
                  }}
                />
              </Grid>
            </Grid>
          </FormControl>
          <FormControl fullWidth sx={{ m: 1 }}>
            <TextField
              id="outlined-basic2"
              label="Количество лет"
              variant="outlined"
              value={anketa.years}
              onChange={(e) => {
                setAnketa({
                  ...anketa,
                  years: e.target.value,
                });
              }}
            />
          </FormControl>

          <h4>Фотография</h4>
          <FormControl
            fullWidth
            sx={{ m: 1, flexDirection: "row", flexWrap: "wrap" }}
          >
            <LoadButton variant="contained" component="label">
              <svg
                fill="#ffffff"
                width="50"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path d="M149.1 64.8L138.7 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H373.3L362.9 64.8C356.4 45.2 338.1 32 317.4 32H194.6c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z" />
              </svg>
              Загрузить изображения
              <input
                type="file"
                multiple={true}
                hidden
                onChange={(e) => {
                  if (!e.target?.files?.length) return;
                  const src = URL.createObjectURL(e.target.files[0]);
                  setAnketa({
                    ...anketa,
                    photo: {
                      buffer: e.target.files[0],
                      src,
                    },
                  });
                }}
              />
            </LoadButton>
            {anketa?.photo?.src && (
              <img
                alt=""
                src={anketa?.photo?.src}
                style={{
                  height: "160px",
                  margin: "5px",
                  objectFit: "cover",
                  display: "inline-block",
                }}
              />
            )}
          </FormControl>

          <h4>Фон</h4>
          <FormControl
            fullWidth
            sx={{ m: 1, flexDirection: "row", flexWrap: "wrap" }}
          >
            <LoadButton variant="contained" component="label">
              <svg
                fill="#ffffff"
                width="50"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path d="M149.1 64.8L138.7 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H373.3L362.9 64.8C356.4 45.2 338.1 32 317.4 32H194.6c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z" />
              </svg>
              Загрузить изображения
              <input
                type="file"
                multiple={true}
                hidden
                onChange={(e) => {
                  if (!e.target?.files?.length) return;
                  const src = URL.createObjectURL(e.target.files[0]);
                  setAnketa({
                    ...anketa,
                    bg: { buffer: e.target.files[0], src },
                  });
                }}
              />
            </LoadButton>
            {anketa?.bg?.src && (
              <img
                alt=""
                src={anketa?.bg?.src}
                style={{
                  height: "160px",
                  margin: "5px",
                  objectFit: "cover",
                  display: "inline-block",
                }}
              />
            )}
          </FormControl>

          {allowFields?.epitafia && (
            <>
              <h4>Эпитафия</h4>
              <FormControl fullWidth sx={{ m: 1 }}>
                <TextField
                  value={anketa.quoteName}
                  onChange={(e) =>
                    setAnketa({
                      ...anketa,
                      quoteName: e.target.value,
                    })
                  }
                  id="outlined-basic2"
                  label="Автор эпитафии"
                  variant="outlined"
                />
              </FormControl>
              <FormControl fullWidth sx={{ m: 1 }}>
                <Textarea
                  value={anketa.quote}
                  onChange={(e) =>
                    setAnketa({
                      ...anketa,
                      quote: e.target.value,
                    })
                  }
                  aria-label="minimum height"
                  minRows={5}
                  placeholder="Краткая эпитафия"
                />
              </FormControl>
            </>
          )}

          <h4>Краткая информация</h4>
          <FormControl fullWidth sx={{ m: 1 }}>
            <Grid container spacing={2}>
              <Grid item xs={6} md={6}>
                <TextField
                  fullWidth
                  id="outlined-basic2"
                  value={anketa.subData.placeBorn}
                  onChange={(e) =>
                    setAnketa({
                      ...anketa,
                      subData: {
                        ...anketa.subData,
                        placeBorn: e.target.value,
                      },
                    })
                  }
                  label="Место рождения"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <TextField
                  fullWidth
                  value={anketa.subData.placeLive}
                  onChange={(e) =>
                    setAnketa({
                      ...anketa,
                      subData: {
                        ...anketa.subData,
                        placeLive: e.target.value,
                      },
                    })
                  }
                  id="outlined-basic2"
                  label="Место проживания"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <TextField
                  fullWidth
                  value={anketa.subData.placeEnd}
                  onChange={(e) =>
                    setAnketa({
                      ...anketa,
                      subData: {
                        ...anketa.subData,
                        placeEnd: e.target.value,
                      },
                    })
                  }
                  id="outlined-basic2"
                  label="Место захоронения"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <TextField
                  fullWidth
                  id="outlined-basic2"
                  label="Родители"
                  variant="outlined"
                  value={anketa.subData.parents}
                  onChange={(e) =>
                    setAnketa({
                      ...anketa,
                      subData: {
                        ...anketa.subData,
                        parents: e.target.value,
                      },
                    })
                  }
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <TextField
                  fullWidth
                  value={anketa.subData.brothers}
                  onChange={(e) =>
                    setAnketa({
                      ...anketa,
                      subData: {
                        ...anketa.subData,
                        brothers: e.target.value,
                      },
                    })
                  }
                  id="outlined-basic2"
                  label="Братья и сестры"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <TextField
                  fullWidth
                  value={anketa.subData.partner}
                  onChange={(e) =>
                    setAnketa({
                      ...anketa,
                      subData: {
                        ...anketa.subData,
                        partner: e.target.value,
                      },
                    })
                  }
                  id="outlined-basic2"
                  label="Супруга / Супруг"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <TextField
                  fullWidth
                  id="outlined-basic2"
                  value={anketa.subData.children}
                  onChange={(e) =>
                    setAnketa({
                      ...anketa,
                      subData: {
                        ...anketa.subData,
                        children: e.target.value,
                      },
                    })
                  }
                  label="Дети"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <TextField
                  fullWidth
                  id="outlined-basic2"
                  label="Образование"
                  variant="outlined"
                  value={anketa.subData.education}
                  onChange={(e) =>
                    setAnketa({
                      ...anketa,
                      subData: {
                        ...anketa.subData,
                        education: e.target.value,
                      },
                    })
                  }
                />
              </Grid>
            </Grid>
          </FormControl>

          {allowFields?.tree && (
            <>
              <h4>Родственники</h4>
              <FormControl fullWidth sx={{ m: 1 }}>
                <Grid container spacing={2}>
                  {relationsResult &&
                    relationsResult
                      ?.sort((a, b) => (a.anketa?.id === id ? -1 : 1))
                      ?.map((item, key) => (
                        <React.Fragment key={`${item.anketa.name}-${key}`}>
                          <Grid item xs={6} md={6}>
                            <TextField
                              fullWidth
                              disabled
                              label="ФИО"
                              variant="outlined"
                              value={item.anketa.name}
                            />
                          </Grid>
                          <Grid item xs={2} md={2}>
                            <TextField
                              fullWidth
                              label="Положение в семье"
                              variant="outlined"
                              onChange={(e) => {
                                const newRelations = [...relationsResult];
                                newRelations[key].relation = e.target.value;
                                setRelationsResult(newRelations);
                              }}
                              value={item?.relation}
                            />
                          </Grid>
                          <Grid item xs={2} md={2}>
                            <FormControl fullWidth>
                              <InputLabel id="demo-simple-select-label">
                                Позиция на дереве
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Позиция в дереве"
                                onChange={(e) => {
                                  const newRelations = [...relationsResult];
                                  newRelations[key].position = Number(
                                    e.target.value
                                  );
                                  setRelationsResult(newRelations);
                                }}
                                value={item.position}
                              >
                                {treePositions.map((pos, key) => (
                                  <MenuItem
                                    key={`${pos}-${key}-tree`}
                                    value={pos}
                                  >
                                    {pos}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
                          {((!tariffid && item?.anketa?.id !== id) ||
                            (tariffid && item?.anketa?.id)) && (
                            <Grid item xs={2} md={2}>
                              <Button
                                variant="contained"
                                component="label"
                                fullWidth
                                sx={{ height: "56px" }}
                                onClick={(e) => {
                                  const newRelations = [];
                                  if (relationsResult?.length === 0) {
                                    newRelations.push(initialRelation);
                                  }
                                  newRelations.push(...relationsResult);
                                  newRelations.splice(key, 1);
                                  setRelationsResult(newRelations);
                                }}
                              >
                                Удалить
                              </Button>
                            </Grid>
                          )}
                        </React.Fragment>
                      ))}
                  <Grid item xs={12} md={12}>
                    <TreeAutocomplete
                      relationsResult={relationsResult}
                      setRelationsResult={setRelationsResult}
                    />
                  </Grid>
                </Grid>
              </FormControl>
              <h4>Позиции на дереве</h4>
              <TreeBlankImg src={treeBlank} />
            </>
          )}

          {allowFields?.bio && (
            <RepeatableTextImageSection
              title="Биография"
              field="bio"
              blocks={anketa.bio}
              nameLabel="Название блока"
              textPlaceholder="Текст"
              anketa={anketa}
              setAnketa={setAnketa}
            />
          )}

          {allowFields?.solder && (
            <RepeatableTextImageSection
              title="Награды"
              field="honor"
              blocks={anketa.honor}
              nameLabel="Наименование награды"
              textPlaceholder="История получения награды"
              anketa={anketa}
              setAnketa={setAnketa}
            />
          )}

          {allowFields?.solder && (
            <RepeatableTextImageSection
              title="Боевой путь"
              field="honorWay"
              blocks={anketa.honorWay}
              nameLabel="Наименование награды"
              textPlaceholder="История получения награды"
              anketa={anketa}
              setAnketa={setAnketa}
            />
          )}

          {allowFields?.gallery && (
            <>
              <h4>Галерея</h4>
              <FormControl fullWidth sx={{ m: 1 }}>
                <LoadedImagesContainer>
                  <LoadButton
                    variant="contained"
                    component="label"
                    sx={{ mb: 1 }}
                  >
                    <svg
                      fill="#ffffff"
                      width="50"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path d="M149.1 64.8L138.7 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H373.3L362.9 64.8C356.4 45.2 338.1 32 317.4 32H194.6c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z" />
                    </svg>
                    Загрузить изображения
                    <input
                      type="file"
                      multiple={true}
                      hidden
                      onChange={(e) => {
                        if (!e.target?.files?.length) return;
                        const fileList: File[] = Array.from(e.target.files);
                        const images: { buffer: File; src: string }[] =
                          fileList.map((file) => {
                            return {
                              buffer: file,
                              src: URL.createObjectURL(file),
                            };
                          });
                        setAnketa({
                          ...anketa,
                          gallery: [...(anketa?.gallery ?? []), ...images],
                        });
                      }}
                    />
                  </LoadButton>
                  {anketa.gallery &&
                    anketa.gallery.map((img, k) => (
                      <LoadedImageBox key={`${img.src}-${k}-gallery`}>
                        <LoadedImage src={img.src} />
                        <LoadedImageRemove
                          onClick={(e) => {
                            const newBio = [...anketa.gallery];
                            newBio.splice(k, 1);
                            setAnketa({
                              ...anketa,
                              gallery: newBio,
                            });
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 384 512"
                          >
                            <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                          </svg>
                        </LoadedImageRemove>
                      </LoadedImageBox>
                    ))}
                </LoadedImagesContainer>
              </FormControl>
            </>
          )}
          {allowFields?.video && (
            <>
              <h4>Видео</h4>
              <FormControl fullWidth sx={{ m: 1 }}>
                <LoadButton variant="contained" component="label">
                  <svg
                    fill="#ffffff"
                    width="50"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path d="M149.1 64.8L138.7 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H373.3L362.9 64.8C356.4 45.2 338.1 32 317.4 32H194.6c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z" />
                  </svg>
                  Загрузить видео
                  <input
                    type="file"
                    hidden
                    onChange={(e) => {
                      if (!e.target?.files?.length) return;
                      const src = URL.createObjectURL(e.target.files[0]);
                      setAnketa({
                        ...anketa,
                        video: {
                          buffer: e.target.files[0],
                          src,
                          type: e.target.files[0].type,
                        },
                      });
                    }}
                  />
                </LoadButton>
                {anketa?.video?.src && (
                  <video width="100%" controls>
                    <source
                      src={anketa?.video?.src}
                      type={
                        ["video/mp4", "video/webm", "video/ogg"].includes(
                          anketa?.video?.type as string
                        )
                          ? (anketa?.video?.type as string)
                          : "video/mp4"
                      }
                    />
                    Ваш браузер не поддерживает видео тег.
                  </video>
                )}
              </FormControl>
            </>
          )}

          {allowFields?.media && (
            <>
              <h4>Видео из соц. сетей</h4>
              <FormControl fullWidth sx={{ m: 1 }}>
                <Grid container spacing={2}>
                  {anketa.mediaLinks &&
                    anketa.mediaLinks.map((link, key) => (
                      <>
                        <Grid item xs={12} md={12}>
                          <TextField
                            fullWidth
                            label="Вставьте код iframe из соц сети"
                            variant="outlined"
                            value={link}
                            onChange={(e) => {
                              const newLinks = [...anketa.mediaLinks];
                              newLinks[key] = e.target.value;
                              setAnketa({
                                ...anketa,
                                mediaLinks: newLinks,
                              });
                            }}
                          />
                          {link && link !== "" && (
                            <Box
                              sx={{ mt: 1 }}
                              dangerouslySetInnerHTML={{ __html: link }}
                            ></Box>
                          )}
                        </Grid>
                      </>
                    ))}
                </Grid>
                <Button
                  variant="contained"
                  sx={{ mt: 2 }}
                  onClick={() => {
                    const newLinks = [...(anketa?.mediaLinks ?? [])];
                    newLinks.push("");
                    setAnketa({
                      ...anketa,
                      mediaLinks: newLinks,
                    });
                  }}
                >
                  Добавить
                </Button>
              </FormControl>
            </>
          )}

          <h4>Ссылки на социальные сети</h4>
          <FormControl fullWidth sx={{ m: 1 }}>
            <Grid container spacing={2}>
              {anketa.socialLinks &&
                anketa.socialLinks.map((link, key) => (
                  <>
                    <Grid item xs={12} md={12}>
                      <TextField
                        fullWidth
                        label="Вставьте ссылку на профиль социальной сети"
                        variant="outlined"
                        value={link}
                        onChange={(e) => {
                          const newLinks = [...anketa.socialLinks];
                          newLinks[key] = e.target.value;
                          setAnketa({
                            ...anketa,
                            socialLinks: newLinks,
                          });
                        }}
                      />
                    </Grid>
                  </>
                ))}
            </Grid>
            <Button
              variant="contained"
              sx={{ mt: 2 }}
              onClick={() => {
                const newLinks = [...(anketa?.socialLinks ?? [])];
                newLinks.push("");
                setAnketa({
                  ...anketa,
                  socialLinks: newLinks,
                });
              }}
            >
              Добавить
            </Button>
          </FormControl>

          {allowFields?.map && (
            <>
              <h4>Захоронение</h4>
              <FormControl fullWidth sx={{ m: 1 }}>
                <TextField
                  id="outlined-basic2"
                  label="Наименование кладбища"
                  variant="outlined"
                  value={anketa.graveyard.name}
                  onChange={(e) => {
                    setAnketa({
                      ...anketa,
                      graveyard: {
                        ...anketa.graveyard,
                        name: e.target.value,
                      },
                    });
                  }}
                />
              </FormControl>
              <FormControl fullWidth sx={{ m: 1 }}>
                <TextField
                  id="outlined-basic2"
                  label="Как найти захоронение"
                  variant="outlined"
                  value={anketa.graveyard.description}
                  onChange={(e) => {
                    setAnketa({
                      ...anketa,
                      graveyard: {
                        ...anketa.graveyard,
                        description: e.target.value,
                      },
                    });
                  }}
                />
              </FormControl>
              <MapSelect
                setNewCoords={setNewCoords}
                newCoords={newCoords}
                address={address}
                setAddress={setAddress}
              />
            </>
          )}
          {allowFields?.customImage && (
            <>
              <h4>Параметры для QR кода</h4>
              <FormControl fullWidth sx={{ m: 1 }}>
                <TextField
                  value={anketa.customImageText}
                  inputProps={{ maxLength: 20 }}
                  onChange={(e) =>
                    setAnketa({
                      ...anketa,
                      customImageText: e.target.value,
                    })
                  }
                  id="outlined-basic2"
                  label="1 строка. Максимальное количество символов - 20"
                  variant="outlined"
                />
              </FormControl>
              <FormControl fullWidth sx={{ m: 1 }}>
                <TextField
                  value={anketa.customImageText2}
                  inputProps={{ maxLength: 23 }}
                  onChange={(e) =>
                    setAnketa({
                      ...anketa,
                      customImageText2: e.target.value,
                    })
                  }
                  id="outlined-basic2"
                  label="2 строка. Максимальное количество символов - 23"
                  variant="outlined"
                />
              </FormControl>
              <FormControl fullWidth sx={{ m: 1 }}>
                <TextField
                  value={anketa.customImageText3}
                  inputProps={{ maxLength: 23 }}
                  onChange={(e) =>
                    setAnketa({
                      ...anketa,
                      customImageText3: e.target.value,
                    })
                  }
                  id="outlined-basic2"
                  label="3 строка. Максимальное количество символов - 25"
                  variant="outlined"
                />
              </FormControl>
              <FormControl fullWidth sx={{ m: 1 }}>
                <InputLabel id="demo-simple-select-label3">
                  Форма линий
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label3"
                  id="demo-simple-select3"
                  label="Форма линий"
                  onChange={(e) => {
                    setAnketa({
                      ...anketa,
                      customQRCode: {
                        ...anketa.customQRCode,
                        type: e.target.value,
                      },
                    });
                  }}
                  value={anketa?.customQRCode?.type}
                >
                  <MenuItem value="square">Квадратная</MenuItem>
                  <MenuItem value="rounded">Скругленная</MenuItem>
                  <MenuItem value="classy">Стильная</MenuItem>
                  <MenuItem value="classy-rounded">
                    Стильная Округленная
                  </MenuItem>
                </Select>
              </FormControl>
              <Grid
                container
                spacing={2}
                sx={{ marginLeft: "-8px", marginTop: "5px" }}
              >
                <Grid item xs={6} sm={2}>
                  <LoadButton
                    variant="contained"
                    component="label"
                    sx={{ width: "100%", height: "100%", margin: "0px" }}
                  >
                    <svg
                      fill="#ffffff"
                      width="50"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path d="M149.1 64.8L138.7 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H373.3L362.9 64.8C356.4 45.2 338.1 32 317.4 32H194.6c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z" />
                    </svg>
                    Загрузить свое изображение для QR кода
                    <input
                      type="file"
                      hidden
                      onChange={(e) => {
                        if (!e.target?.files?.length) return;
                        const src = URL.createObjectURL(e.target.files[0]);
                        const _URL = window.URL || window.webkitURL;
                        const img = new Image();
                        if (e?.target?.files[0]) {
                          const objectUrl = _URL.createObjectURL(
                            e.target.files[0]
                          );
                          const blob = e.target.files[0];
                          img.onload = function () {
                            const { width, height } = getCustomImageSize(
                              img.width,
                              img.height
                            );
                            setAnketa({
                              ...anketa,
                              customImage: {
                                ...anketa.customImage,
                                buffer: blob,
                                src,
                                width,
                                height,
                              },
                            });
                            qrCode.update({
                              width: 100,
                              height: 100,
                            });
                            _URL.revokeObjectURL(objectUrl);
                          };
                          img.src = objectUrl;
                        }
                      }}
                    />
                  </LoadButton>
                </Grid>
                {qrCodeImages.map((image) => (
                  <Grid item xs={6} sm={2} key={image}>
                    <Card>
                      <CardActionArea onClick={() => handleSelectImage(image)}>
                        <CardMedia
                          component="img"
                          height="180"
                          image={image}
                          sx={{ objectFit: "contain", padding: "10px" }}
                        />
                        <Checkbox
                          checked={selectedImages === image}
                          style={{ position: "absolute", top: 8, right: 8 }}
                          onChange={() => handleSelectImage(image)}
                        />
                      </CardActionArea>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </>
          )}

          <CustomQRCodeExampleContainer>
            {anketa?.customImage?.src && (
              <img
                alt=""
                src={anketa?.customImage?.src}
                width={anketa?.customImage?.width ?? 0}
                height={anketa?.customImage?.height ?? 0}
                style={{
                  objectFit: "contain",
                  display: "inline-block",
                  position: "absolute",
                  zIndex: 0,
                  maxWidth: "100%",
                }}
              />
            )}
            <div style={{ zIndex: 1 }} ref={refQR} />
          </CustomQRCodeExampleContainer>
          {allowFields?.customImage && (
            <>
              {anketa?.customImage?.src && (
                <>
                  <h4>Примеры применения QR кода</h4>
                  <p>
                    <b>ВНИМАНИЕ!</b> QR код ведет на главную страницу сайта. Для
                    актуализации ссылки нужно создать страницу
                  </p>
                  <QRCodeContainer>
                    <QRCodeConfigurator
                      image={{
                        src: anketa?.customImage?.src,
                        params: {
                          width: anketa?.customImage?.width ?? 0,
                          height: anketa?.customImage?.height ?? 0,
                        },
                      }}
                      qr={qrSrc}
                      text={[
                        { text: `${anketa.customImageText ?? anketa.name}` },
                        {
                          text: `${
                            anketa.customImageText2 ??
                            `${anketa.dateBorn} - ${anketa.dateEnd}`
                          }`,
                        },
                        { text: anketa?.customImageText3 ?? "" },
                      ]}
                      type={TypeConfigurator.board}
                    />
                    <QRCodeConfigurator
                      image={{
                        src: anketa?.customImage?.src,
                        params: {
                          width: anketa?.customImage?.width ?? 0,
                          height: anketa?.customImage?.height ?? 0,
                        },
                      }}
                      qr={qrSrc}
                      text={[
                        { text: `${anketa.customImageText ?? anketa.name}` },
                        {
                          text: `${
                            anketa.customImageText2 ??
                            `${anketa.dateBorn} - ${anketa.dateEnd}`
                          }`,
                        },
                        { text: anketa?.customImageText3 ?? "" },
                      ]}
                      type={TypeConfigurator.table}
                    />
                    <QRCodeConfigurator
                      image={{
                        src: anketa?.customImage?.src,
                        params: {
                          width: anketa?.customImage?.width ?? 0,
                          height: anketa?.customImage?.height ?? 0,
                        },
                      }}
                      qr={qrSrc}
                      text={[
                        { text: `${anketa.customImageText ?? anketa.name}` },
                        {
                          text: `${
                            anketa.customImageText2 ??
                            `${anketa.dateBorn} - ${anketa.dateEnd}`
                          }`,
                        },
                        { text: anketa?.customImageText3 ?? "" },
                      ]}
                      type={TypeConfigurator.memorial}
                    />
                  </QRCodeContainer>
                </>
              )}
            </>
          )}

          {anketa.AnketaService && anketa.AnketaService.length > 0 && (
            <>
              {!r && (
                <>
                  <h4>Доходы</h4>
                  {anketa.AnketaService.map((service, index) => ({
                    service,
                    index,
                  }))
                    .filter(({ service }) => service.type === "INCOME")
                    .map(({ service, index }) => (
                      <FormControl
                        fullWidth
                        sx={{ m: 1 }}
                        key={`${service.serviceId}-${service.anketaId}`}
                      >
                        <TextField
                          value={service.price}
                          inputProps={{ maxLength: 23 }}
                          type={"number"}
                          onChange={(e) =>
                            handleServicePriceChange(
                              index,
                              Number(e.target.value)
                            )
                          }
                          id="outlined-basic2"
                          label={service.title}
                          variant="outlined"
                        />
                      </FormControl>
                    ))}
                  <h4>Расходы</h4>
                  {anketa.AnketaService.map((service, index) => ({
                    service,
                    index,
                  }))
                    .filter(({ service }) => service.type === "COST")
                    .map(({ service, index }) => (
                      <FormControl
                        fullWidth
                        sx={{ m: 1 }}
                        key={`${service.serviceId}-${service.anketaId}`}
                      >
                        <TextField
                          value={service.price}
                          inputProps={{ maxLength: 23 }}
                          type={"number"}
                          onChange={(e) =>
                            handleServicePriceChange(
                              index,
                              Number(e.target.value)
                            )
                          }
                          id="outlined-basic2"
                          label={service.title}
                          variant="outlined"
                        />
                      </FormControl>
                    ))}
                </>
              )}
            </>
          )}

          {!r && (
            <>
              <h4>Комментарий к анкете</h4>
              <Textarea
                aria-label="minimum height"
                placeholder="Комментарий к анкете"
                minRows={5}
                sx={{ mb: 2 }}
                value={anketa.comment}
                onChange={(e) => {
                  setAnketa({
                    ...anketa,
                    comment: e.target.value,
                  });
                }}
              />
            </>
          )}

          <Button
            onClick={(e) => handleSubmit(e)}
            sx={{ m: 1, width: "100%" }}
            variant="contained"
          >
            {tariffid ? "Создать страницу" : "Сохранить страницу"}
          </Button>
        </Grid>
      </Container>
      <AlertSuccess
        open={openSaveAlert}
        setOpen={setOpenSaveAlert}
        message="Страница успешно сохранена"
      />
    </>
  );
};

export default ChangePage;
